import { render, staticRenderFns } from "./TheLiteModal.vue?vue&type=template&id=04b3153c&"
import script from "./TheLiteModal.vue?vue&type=script&lang=js&"
export * from "./TheLiteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b3153c')) {
      api.createRecord('04b3153c', component.options)
    } else {
      api.reload('04b3153c', component.options)
    }
    module.hot.accept("./TheLiteModal.vue?vue&type=template&id=04b3153c&", function () {
      api.rerender('04b3153c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/TheLiteModal.vue"
export default component.exports